import { Tooltip, Card } from "@heroui/react";
import CardTooltip from "@/components/DeckBuilder/CardTooltip";
import { getCardData } from "@/lib/games/onePiece/getCardDataLocal";

function getBgColor(color: string) {
  let bg = "bg-zinc-900";
  if (color.toLowerCase() === "red") {
    bg = "bg-red-700";
  } else if (color.toLowerCase() === "green") {
    bg = "bg-green-700";
  } else if (color.toLowerCase() === "blue") {
    bg = "bg-blue-600";
  } else if (color.toLowerCase() === "purple") {
    bg = "bg-purple-700";
  } else if (color.toLowerCase() === "black") {
    bg = "bg-zinc-700";
  } else if (color.toLowerCase() === "yellow") {
    bg = "bg-yellow-400";
  }
  return bg;
}

function getColor(color: string) {
  let text = "text-white";
  let bg;

  if (color.toLowerCase().includes("/")) {
    const colors = color.toLowerCase().split("/");
    const color1 = getBgColor(colors[0]).replace("bg", "from");
    const color2 = getBgColor(colors[1]).replace("bg", "to");
    bg = `bg-gradient-to-r ${color1} from-35% ${color2} to-65%`;
  } else {
    bg = getBgColor(color);
  }

  if (color.toLowerCase() === "yellow") {
    text = "text-black";
  }

  return [text, bg].join(" ");
}

function getDropShadow(color: string) {
  if (color.toLowerCase() === "yellow") {
    return "";
  }
  return "drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]";
}

export default function DeckCardLeftSide({
  id,
  count,
  addCard,
}: {
  id: string;
  count: number;
  addCard: any;
}) {
  const cardData = getCardData(id);

  if (!cardData) {
    return;
  }

  return (
    <Card
      key={id}
      radius="none"
      className="rounded-full p-0 m-0 outline outline-1 outline-transparent hover:shadow-[0_0_12px_rgba(255,255,255,0.4)] hover:outline-white transition-all"
    >
      <div className="flex flex-row w-full items-center overflow-visible">
        <div className="relative group/add">
          <div className="px-2 w-10 flex flex-row items-end rounded-full bg-white text-black font-bold shadow-[0_0_6px_rgba(0,0,0,0.3)]">
            {count}x
          </div>
          <div
            className="group-hover/add:visible invisible absolute bg-red-500 z-20 w-10 top-0"
            onClick={(e) => {
              addCard(id, 1);
            }}
          >
            +
          </div>
        </div>
        <div
          className="w-full flex flex-row items-center h-full"
          onClick={() => addCard(id, -1)}
        >
          <Tooltip
            className="bg-default-100"
            classNames={{ base: "pointer-events-none" }}
            disableAnimation
            delay={0}
            closeDelay={0}
            placement="right"
            content={<CardTooltip id={id} />}
          >
            <div className="w-full">
              <div
                className={
                  "p-1 max-w-full rounded-full flex items-center " +
                  getColor(cardData.color)
                }
              >
                <div className="rounded-full bg-black text-xs text-white min-w-[20px] min-h-[20px] w-[20px] h-[20px] flex items-center justify-center">
                  {cardData.cost === undefined ? "L" : cardData.cost}
                </div>
                <div className="ml-1 break-words line-clamp-1 text-left">
                  <span className={getDropShadow(cardData.color)}>
                    {cardData.name}
                  </span>
                </div>
              </div>
            </div>
          </Tooltip>
        </div>
      </div>
    </Card>
  );
}
